import React from 'react'
import { capitalizeFirstLetter } from '../../../helpers'
import { ReactComponent as TresdIcon } from '../../../assets/img/icons/tresd-icon.svg'
import LocalizedLink from '../../global/LocalizedLink'
import Translation from '../../global/Translation'
import DisplayBrand from '../../catalog/rectangleResult/displays/DisplayBrand'

const ConfigBathCard = props => {
    const { data } = props

    const brands = Object.entries(data.fullConfig.brands)
        .filter(([key, value]) => value.length > 0)
        .map(([key, value]) => key)
        .sort()

    return (
        <div className="config__bath__card">
            {/* Image */}
            <div className="config__bath__card--img">
                <img src={data.defaultImageModelUrl} alt={capitalizeFirstLetter(data.model)} />
            </div>

            {/* Info */}
            <div className="config__bath__card--info">
                <div className="brand">
                    {brands.map((brand, index) => (
                        <span key={index}>
                            <DisplayBrand brand={brand} span={true} />{' '}
                        </span>
                    ))}
                </div>
                <div className="name">
                    <span>{capitalizeFirstLetter(data.model)}</span>
                </div>
            </div>

            <div className="x-divider"></div>

            {/* Price */}
            <div className="config__bath__card--price">
                <div>{/* <span>Desde:&nbsp;{data.price}</span> */}</div>
            </div>

            {/* Config btn */}
            <div className="config__bath__card--btn">
                <LocalizedLink
                    routeId="ROUTE_CONFIG_CUT_TO_SIZE"  //'/configurables/:type/:model/:fabricator/:refcode?'
                    params={{ type: data.type, model: data.model.toLowerCase().replace(' ', '_'), refcode: '', fabricator: props.fabricator }}
                >
                    <Translation id="custom_configuration" defaultMessage="Custom configuration" /> <TresdIcon />
                </LocalizedLink>
            </div>
        </div>
    )
}

export default ConfigBathCard
